(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["formato-selettore"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__icfFormatoBound) return;
    window.__icfFormatoBound = true;

    function fire(el, type) {
      el.dispatchEvent(new Event(type, { bubbles: true }));
    }

    // 1) Prova a pilotare il selettore varianti nativo del tema.
    //    Match per data-variant-id oppure, in mancanza, per valore opzione (radio/select).
    function selectNative(scope, vid, optValue) {
      var pickers = scope.querySelectorAll('variant-picker, .variant-picker');
      for (var p = 0; p < pickers.length; p++) {
        var picker = pickers[p];

        var input = picker.querySelector('input[data-variant-id="' + vid + '"]');
        if (!input && optValue) {
          var radios = picker.querySelectorAll('input[type="radio"]');
          for (var i = 0; i < radios.length; i++) {
            if (radios[i].value === optValue) { input = radios[i]; break; }
          }
        }
        if (input) {
          if (!input.checked) input.checked = true;
          fire(input, 'input');
          fire(input, 'change');
          return true;
        }

        var opt = picker.querySelector('option[data-variant-id="' + vid + '"]');
        if (!opt && optValue) {
          var opts = picker.querySelectorAll('option');
          for (var j = 0; j < opts.length; j++) {
            if (opts[j].value === optValue || opts[j].textContent.trim() === optValue) { opt = opts[j]; break; }
          }
        }
        if (opt) {
          var sel = opt.closest('select');
          if (sel) {
            if (sel.value !== opt.value) {
              sel.value = opt.value;
              fire(sel, 'change');
            }
            return true;
          }
        }
      }
      return false;
    }

    // 2) In ogni caso aggiorna direttamente l'input id dei form "aggiungi al carrello":
    //    e questo il fix per l'errore del bottone carrello (variante non sincronizzata).
    function syncForms(scope, vid) {
      var inputs = scope.querySelectorAll('form[action*="/cart/add"] input[name="id"]');
      if (!inputs.length) inputs = document.querySelectorAll('form[action*="/cart/add"] input[name="id"]');
      var done = false;
      for (var i = 0; i < inputs.length; i++) {
        if (inputs[i].value !== String(vid)) {
          inputs[i].value = vid;
          fire(inputs[i], 'change');
        }
        done = true;
      }
      return done;
    }

    // Delegated: survives the theme re-rendering the product section
    document.addEventListener('click', function (e) {
      var row = e.target.closest('.ikoru-formato__row');
      if (!row) return;
      var vid = row.getAttribute('data-variant-id');
      if (!vid) return;

      var scope = row.closest('.shopify-section') || document;
      var nativeOk = selectNative(scope, vid, row.getAttribute('data-option-value'));
      var formOk = syncForms(scope, vid);

      if (nativeOk || formOk) {
        var list = row.closest('.ikoru-formato__list');
        if (list) {
          list.querySelectorAll('.ikoru-formato__row').forEach(function (r) { r.classList.remove('is-selected'); });
        }
        row.classList.add('is-selected');
        var url = row.getAttribute('data-url');
        if (url && window.history && history.replaceState && !window.Shopify?.designMode) {
          history.replaceState({}, '', url);
        }
      } else if (row.getAttribute('data-url')) {
        // fallback solo se in pagina non ci sono ne selettore nativo ne form carrello
        window.location.href = row.getAttribute('data-url');
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
